
    <div id="chart_div_{{this.PlayerId}}_{{this.TestId}}" [style.height.px]="this.ChartHeight" >
  
    </div>
    
    

